import {Button, comp, Component, Config, datasourcestore, EntityID} from "@intermesh/goui";
import {t} from "../util/Translate.js";
import {ServerApi} from "../util/ServerApi.js";
import {messageUserDS, messageUserStore} from "../data/MessagesStore.js";
import {UserMessageListDialog} from "../UserMessageListDialog.js";
import {UserMessageDialog} from "../UserMessageDialog.js";

export class ServiceMessages {

	private notificationCount: number = 0;

	private readonly counterCmp: Component;

	private store: typeof messageUserStore | undefined

	constructor() {
		this.counterCmp = comp({tagName: "span", cls: "go-counter", text: String(this.notificationCount)});

		this.store = datasourcestore({dataSource: messageUserDS, queryParams: {limit: 0}});
	}

	async showAutomaticPopups() {
		for (const i of this.store!.getArray()) {
			if (!i.message.showPopup) {
				continue;
			}
			if (i.seen) {
				if (i.message.showOnce) {
					continue;
				} else if (i.dismissed) {
					continue;
				}
			}
			const w = new UserMessageDialog(i);

			w.on("hide", async () => {
				await this.store!.reload();
			});
			w.show();
		}
	}

	async showMessages() {
		const d = new UserMessageListDialog();
		const items = this.store!.getArray().filter((i) => {
			return (!i.seen || !i.message.showOnce);
		});
		d.loadData(items);
		d.on("close", () => {
			this.load().then(() => {
				this.updateNotificationCount()
			});
		});
		d.show();
	}

	displayNotificationCount(btn: ServiceMessagesBtn) {
		this.updateNotificationCount();
		if (this.notificationCount > 0) {
			btn.parent!.items.insert(btn.parent!.items.indexOf(btn) + 1, this.counterCmp);
			this.counterCmp.text = String(this.notificationCount);
		} else if(btn.parent!.items) {
			btn.parent!.items.remove(this.counterCmp);
		}
	}

	load() {
		return this.store!.load(false);
	}

	markRead(id: EntityID, markDismissed: boolean = false) {
		const url = ServerApi.url('messaging/messageuser/' + id, {});
		return ServerApi.call(url, {seen: true, dismissed: markDismissed}, "PUT");
	}

	private updateNotificationCount() {
		this.notificationCount = 0;
		for (let item of this.store!.getArray()) {
			if (!item.seen) {
				this.notificationCount++;
			}
		}
	}

}

export class ServiceMessagesBtn extends Button {

	public notificationsBtn: Button | undefined;

	constructor() {
		super();
		const sm = new ServiceMessages;
		this.icon = "announcement";
		this.cls = "ifw-top-btn";
		this.title = t("Service messages");
		this.handler = async function (_btn) {
			await sm.showMessages();
		}
		this.on("render", () => {
			sm.load().then(async () => {
				await sm.showAutomaticPopups();
				sm.displayNotificationCount(this);
			});

		});
	}
}


export const serviceMessagesBtn = (config?: Config<ServiceMessagesBtn>) => Object.assign(new ServiceMessagesBtn(), config);
